import { render, staticRenderFns } from "./IPO.vue?vue&type=template&id=2021a79e&scoped=true"
import script from "./IPO.vue?vue&type=script&lang=js"
export * from "./IPO.vue?vue&type=script&lang=js"
import style0 from "./IPO.vue?vue&type=style&index=0&id=2021a79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2021a79e",
  null
  
)

export default component.exports